<template>
  <div>
    <div class="grid xl:flex gap-4 items-center mb-4">
      <h5 class="flex items-center"><i class="dot"></i>{{ $t('주간 이행사항 점검 및 회의') }}</h5>
      <div v-if="!readonly && !isPrint" class="ml-auto">
        <vs-button color="secondary" type="border" @click="handleAddRow">{{ $t('항목추가') }}</vs-button>
        <vs-button class="ml-4" color="secondary" @click="handleRemoveRow">{{ $t('선택삭제') }}</vs-button>
      </div>
    </div>


    <table v-if="isPrint" class="w-full">
      <colgroup>
        <col width="64" />
        <col width="160" />
        <col width="400" />
        <col width="208" />
        <col style="min-width: 540px;"/>
      </colgroup>
      <thead>
        <th>{{ $t('주차') }}</th>
        <th>{{ $t('기간') }}</th>
        <th>{{ $t('⑧ 주간 위험성평가 결과 논의·공유 및 이행상황 점검') }}</th>
        <th>{{ $t('주간 점검 회의 일정') }}</th>
        <th>{{ $t('주간 점검회의 참석자 확인') }}</th>
      </thead>
      <tbody>
        <tr v-for="(item, item_i) in list" :key="item.id">
          <th>{{ item_i + 1 }}주차</th>
          <td>
            <div>
              <div class="print-input">{{item.input1_s}}</div>
              <div class="flex items-center mt-3">
                <p class="mr-2">~</p>
                <div class="print-input">{{item.input1_e}}</div>
              </div>
            </div>
          </td>
          <td>
            <div class="print-textarea">{{item.input2}}</div>
          <td>
            <div class="flex items-center mb-3">
              <p class="mr-3" style="width: 100px;">{{ $t('예정일자') }}</p>
              <span class="print-input">{{item.input3}}</span>
            </div>
            <div class="flex items-center">
              <p class="mr-3" style="width: 100px;">{{ $t('실시일자') }}</p>
              <span class="print-input">{{item.input4}}</span>
            </div>
          </td>
          <td>
            <div class="grid grid-cols-5 gap-y-3 gap-x-2">
              <span class="print-input" >{{item.input5}}</span>
              <span class="print-input" >{{item.input6}}</span>
              <span class="print-input" >{{item.input7}}</span>
              <span class="print-input" >{{item.input8}}</span>
              <span class="print-input" >{{item.input9}}</span>
              <span class="print-input" >{{item.input10}}</span>
              <span class="print-input" >{{item.input11}}</span>
              <span class="print-input" >{{item.input12}}</span>
              <span class="print-input" >{{item.input13}}</span>
              <span class="print-input" >{{item.input14}}</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else style="overflow-x: auto">
      <table>
        <colgroup>
          <col v-if="!readonly" width="36" />
          <col width="64" />
          <col width="160" />
          <col width="400" />
          <col width="208" />
          <col style="min-width: 540px;"/>
        </colgroup>
        <thead>
          <th v-if="!readonly">
            <vs-checkbox :value="checkData.length === list.length && 0 < list.length" class="justify-center mx-0" @click.native="onClickAllCheck" />
          </th>
          <th>{{ $t('주차') }}</th>
          <th>{{ $t('기간') }}</th>
          <th>{{ $t('⑧ 주간 위험성평가 결과 논의·공유 및 이행상황 점검') }}</th>
          <th>{{ $t('주간 점검 회의 일정') }}</th>
          <th>{{ $t('주간 점검회의 참석자 확인') }}</th>
        </thead>
        <tbody>
          <tr v-for="(item, item_i) in list" :key="item.id">
            <td v-if="!readonly" style="background: #f9f9f9"><vs-checkbox v-model="checkData" :vs-value="item.id" /></td>
            <th>{{ item_i + 1 }}주차</th>
            <td>
              <div>
                <DateSelector :readonly="readonly" v-model="item.input1_s" class="w-full" placeholder="시작일" />
                <div class="flex items-center mt-3">
                  <p class="mr-2">~</p>
                  <DateSelector :readonly="readonly" v-model="item.input1_e" class="flex-1 w-full" placeholder="종료일" />
                </div>
              </div>
            </td>
            <td><ml-textarea :readonly="readonly" rows="3" v-model="item.input2" class="w-full mb-0" /></td>
            <td>
              <div class="flex items-center mb-3">
                <p class="mr-3">{{ $t('예정일자') }}</p>
                <DateSelector :readonly="readonly" v-model="item.input3" class="flex-1 w-full" placeholder="시작일" />
              </div>
              <div class="flex items-center">
                <p class="mr-3">{{ $t('실시일자') }}</p>
                <DateSelector :readonly="readonly" v-model="item.input4" class="flex-1 w-full" placeholder="종료일" />
              </div>
            </td>
            <td>
              <div class="grid grid-cols-5 gap-y-3 gap-x-2">
                <ml-input :readonly="readonly" v-model="item.input5" class="w-full" placeholder="1. 현장소장" />
                <ml-input :readonly="readonly" v-model="item.input6" class="w-full" placeholder="2. 근로자대표" />
                <ml-input :readonly="readonly" v-model="item.input7" class="w-full" placeholder="3. 공사과장" />
                <ml-input :readonly="readonly" v-model="item.input8" class="w-full" placeholder="4. 안전관리자" />
                <ml-input :readonly="readonly" v-model="item.input9" class="w-full" placeholder="5. 협력업체소장" />
                <ml-input :readonly="readonly" v-model="item.input10" class="w-full" placeholder="6. 협력업체소장" />
                <ml-input :readonly="readonly" v-model="item.input11" class="w-full" placeholder="7. 협력업체소장" />
                <ml-input :readonly="readonly" v-model="item.input12" class="w-full" placeholder="8. 자필서명" />
                <ml-input :readonly="readonly" v-model="item.input13" class="w-full" placeholder="9. 자필서명" />
                <ml-input :readonly="readonly" v-model="item.input14" class="w-full" placeholder="10. 자필서명" />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import DateSelector from "@/components/selector/DateSelector";

export default {
  components: {
    DisasterClassSelector,
    DateSelector,
  },
  props: {
    readonly: { type: Boolean, default: false },
    isPrint: { type: Boolean, default: false },
    value: { type: Array, default: () => [] },
  },
  data() {
    return {
      checkData: [],
      list: this.value,
      numberId: 0 < this.value.length ? this.value[this.value.length - 1].id : 0,
    };
  },
  watch: {
    value: {
      handler(value) {
        this.list = value;
        this.numberId = 0 < value.length ? value[value.length - 1].id : 0;
      },
    },
    list: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    // All 체크박스 클릭
    onClickAllCheck() {
      if (this.checkData.length === this.list.length) this.checkData = [];
      else this.checkData = this.list.map((item) => item.id);
    },
    // 항목추가
    handleAddRow() {
      const addData = { id: ++this.numberId };
      this.list.push(addData);
    },
    // 선택삭제
    handleRemoveRow() {
      this.list = this.list.filter((item) => !this.checkData.includes(item.id));
      this.checkData = [];
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  th,
  td {
    border: 1px solid #cdcdcd;
    padding: 5px;

    &::v-deep .con-vs-checkbox {
      justify-content: center !important;
      margin: 0;
      span {
        margin: 0;
      }
    }
    &::v-deep .con-vs-radio {
      width: 100%;
      justify-content: center !important;
    }
  }
  th {
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    text-align: center;

    background: #f9f9f9;
    padding: 21px 7px;
  }
}

.disaster::v-deep {
  .con-select {
    width: 100%;
  }
}
</style>
